export const select = [
    {id: 1, continent: 'Africa'},
    {id: 2, continent: 'Americas'},
    {id: 3, continent: 'Asia'},
    {id: 4, continent: 'Europe'},
    {id: 5, continent: 'Oceania'},
]